<div class="container-fluid flex flex-col justify-stretch gap-3">
	<div class="flex flex-row items-center gap-4 mt-4">
		<app-time-range-picker
			[(range)]="this.range"
			[allowDynamic]="true"
			[disabled]="timeLoading$ | async"
			class="justify-center sm:items-start sm:justify-start"
		></app-time-range-picker>
		@if (canDrillBack$ | async) {
		<div class="mat-bg-card flex items-center justify-center rounded-full w-[50px] h-[50px]">
			<button
				(click)="drillBack()"
				[matTooltip]="'utils.back' | translate"
				mat-icon-button
			>
				<mat-icon>undo</mat-icon>
			</button>
		</div>
		}
	</div>
	<div class="timeChart-container">
		<app-loader
			[enableCircle]="true"
			[isActive]="this.timeLoading$ | async"
			[isAfterViewInit]="false"
			class="rounded"
		></app-loader>
		<tg-reports-graph
			[data]="graph$ | async"
			[drillable]="(graphDrillable$ | async) === true"
		></tg-reports-graph>
	</div>
	<div class="flex flex-row flex-wrap items-start justify-start gap-6">
		<div class="flex-fill mb-2 flex items-stretch sm:flex-auto">
			<app-data-table
				(deletedTime)="onDeleteTime($event)"
				(namePress)="onNameClick($event)"
				(restoredTime)="onRestoreTime()"
				[(group)]="this.group"
				[data]="this.data$table | async"
				[showColors]="true"
				[showRoundingButton]="false"
				class="flex-auto"
			></app-data-table>
		</div>
		<div class="mb-2 flex flex-initial flex-col space-y-3 sm:wflex-[0_0_240px]">
			<ng-container *ngIf="this.data$stats | async as tds">
				<div class="flex flex-col gap-2">
					<div class="flex flex-col gap-2">
						<div class="summed-report-time flex flex-col">
							<span class="summed-report-time-header mat-text-primary">{{
								'dashboard.sum' | translate
							}}</span>
							<span>{{ tds.summed | parseMsAsDuration }}</span>
						</div>
						<div class="summed-report-time flex flex-col">
							<span class="summed-report-time-header mat-text-primary">{{
								'dashboard.billed' | translate
							}}</span>
							<span>{{ tds.billed | parseMsAsDuration }}</span>
						</div>
						<div class="summed-report-time flex flex-col">
							<span class="summed-report-time-header mat-text-primary">{{
								'dashboard.nonBilled' | translate
							}}</span>
							<span>{{ tds.nonBilled | parseMsAsDuration }}</span>
						</div>
						<div
							*ngIf="(showAmounts$ | async) && tds.amount as amount"
							class="summed-report-time flex flex-col"
						>
							<span class="summed-report-time-header mat-text-primary">{{
								'insights.earnings' | translate
							}}</span>
							<span>{{ amount.value | customCurrency }}</span>
						</div>
					</div>
					<div
						[style.height.px]="180"
						[style.width.px]="220"
						class="mt-4 sm:flex-auto"
					>
						<div class="pieChart-container">
							<app-loader
								[enableCircle]="true"
								[isActive]="this.timeLoading$ | async"
								[isAfterViewInit]="false"
								class="rounded"
							></app-loader>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
